import React, { useCallback, useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Image,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Typography,
} from 'antd';
import { ModalProps } from 'antd/lib/modal/Modal';
import {
  CloseOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from '@ant-design/icons';

import theme from 'assets/styles/theme';
// import {SelectWarehouse} from 'components/common';
import AmazonSvg from 'assets/icons/Amazon';
import CanadaPostSVG from 'assets/icons/CanadaPost';
import SheinSvg from 'assets/icons/Shein';
import DHLIcon from 'assets/images/dhl.png'
import FedexIcon from 'assets/images/fedEx.png';
import Other from 'assets/images/otherShipping.png';
import Purolator from 'assets/images/logotrans.gif';
import TemuIcon from 'assets/images/temu.png';
import UPSIcon from 'assets/images/ups.png';
import USPSIcon from 'assets/images/usps.png';
import CreateAddressDialog from 'components/Admin/AddressBook/createDialog';
import { FormLabel, Loading, ScreenMask, message } from 'components/common';
import ModalDialog from 'components/common/ModalDialog';
import { COMMON_CARD_WRAPPER_MARGIN, LOADING_ICON_SIZE1 } from 'constants/config';
import { RootState } from 'reducers';
import { getAddressList } from 'services/address';
import { fetchAuthStatus, fetchUpsAuthCode } from 'services/admin';
import { SetShipAccount, getShipAccountById } from 'services/ship';
import {
  getChannelfulfillmentAccounts,
  getShippingProviderAccounts,
  getShippingProviderAccountsCarrierInfo,
} from 'services/shippingProviderAccount';

import CarrierWarehouseSelector from './CarrierWarehouseSelector';
import StoreSelector from './StoreSelector';
import { TwoCol } from './style';

const { Text } = Typography;

interface CreateLotProps extends ModalProps {
  onClose: Function;
  carrier: number;
  carrierKeyValue: { [key: string]: any };
  actionType: 'add' | 'edit';
  accountInfo?: ShipAccountRow;
}

// eslint-disable-next-line
export default (props: CreateLotProps) => {
  const { carrier, actionType, accountInfo, carrierKeyValue } = props;
  const [info, setInfo] = useState<any>();
  const [addressAct, setAddressAct] = useState<'add' | 'edit'>('add');
  const [addressBook, setAddressBook] = useState<AddressRow[]>([]);
  const [authCodeState, setAuthCodeState] = useState<string>();
  const [carrierAccounts, setCarrierAccounts] = useState<any[]>([]);
  const [channelfulfillments, setChannelfulfillments] = useState<any[]>([]);
  const [createlVisible, setCreatelVisible] = useState(false);
  const [detailDialogIsFullscreen, setDetailDialogIsFullscreen] =
    useState(false);
  const [inited, setInited] = useState(false);
  const [isFormTouched, setIsFormTouched] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [lockScreen, setLockScreen] = useState(false);
  const [mode, setMode] = useState<number>(0);
  const [providerAccounts, setProviderAccounts] = useState<any[]>([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<AddressRow>();
  const [selectedChannelAccountNum, setSelectedChannelAccountNum] = useState<number>();
  const [selectedProviderAccount, setSelectedProviderAccount] =
    useState<number>();
  const [selectedUsage, setSelectedUsage] = useState(0);
  const [useSandbox, setUseSandbox] = useState<boolean>();
  const [useProviderAccount, setUseProviderAccount] = useState(carrier === 5 ? 2 : 0);

  const refreshBtnRef = useRef<any>(null);

  const [form] = Form.useForm();

  const warehouses = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );

  // eslint-disable-next-line
  const checkUpsAuthCode = async () => {
    setLockScreen(true);

    try {
      const { code, data } = await fetchUpsAuthCode();

      if (code === 200 && data && typeof data === 'object') {
        if (data.url) window.open(data.url);

        setTimeout(() => {
          setLockScreen(false);
          checkUpsAuthStatus(data.state);
        }, 5000);
      } else {
        message.error({ content: 'Can not get the auth code' });
      }
    } catch(e) {
      setLockScreen(false);
      message.error({ content: `Fetch auth code error: ${e}` });
    } finally {
    }
  };

  const checkUpsAuthStatus = async (state: string) => {
    setLockScreen(true);

    try {
      const { code, data } = await fetchAuthStatus(state);

      if (code === 200) {
        console.log('res', data);
        if (data === 1) {
          setTimeout(() => {
            checkUpsAuthStatus(state);
          }, 5000);
        } else {
          switch(data) {
            case null:
              message.error({ content: 'No auth status data found' });
              break;

            case 2:
              setAuthCodeState(state);
              handleCreate();
              message.success({ content: 'Authentication successful' });
              break;

            case 3:
              message.error({ content: 'Authentication failed' });
              break;

            default:
              message.error({ content: `Unkown auth status: ${data}` });
          }

          setLockScreen(false);
        }
      } else {
        message.error({ content: 'The auth status data format is not right' });
        setLockScreen(false);
      }
    } catch(e) {
      message.error({ content: `Fetch auth status error: ${e}` });
      setLockScreen(false);
    } finally {
    }
  };

  useEffect(()=>{
    setSelectedUsage(info? info.accountUsage: 0)
  },[info])

  const fetchProviderAccounts = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getShippingProviderAccounts();
      setLoading(false);
      if (res.isSuccess) {
        setProviderAccounts(res.data);
      }
    } catch (error) {
      setLoading(false);
    }
  }, []);

  const fetchChannelfulfillmentAccounts = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getChannelfulfillmentAccounts();
      setLoading(false);
      if (res.isSuccess) {
        setChannelfulfillments(res.data);
      }
    } catch (error) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if ([1, 2, 3, 4, 5, 7, 8, 9, 10].indexOf(carrier) > -1) {
      fetchProviderAccounts();
    }
    if ([1, 2, 3].indexOf(carrier) > -1) {
      fetchChannelfulfillmentAccounts();
    }
    if (!inited) {
      if (carrier === 7) {
        //setUseProviderAccount(0);
        setMode(1);
        //console.log('info', info);
      }

      if (carrier === 8) {
        setMode(1);
      }

      setInited(true);
    }
  }, [carrier, fetchProviderAccounts, fetchChannelfulfillmentAccounts, inited]);

  const closeProductDetailDialog = () => {
    if (form.isFieldsTouched()) {
      Modal.confirm({
        title: 'Do you want to leave this page？',
        okText: 'No',
        cancelText: 'Yes',
        cancelButtonProps: { className: 'hover-danger-button' },
        content: `Changes you made may not be saved.`,
        onCancel() {
          props.onClose();
        },
      });
    } else {
      props.onClose();
    }
  };

  const detailDialogWidth = useCallback(
    (isFullscreen = detailDialogIsFullscreen) => {
      return isFullscreen
        ? window.innerWidth - 4
        : window.innerWidth > 1280
          ? window.innerWidth * 0.8
          : 1200;
    },
    [detailDialogIsFullscreen]
  );

  const getDialogDom = () => {
    const refreshBtn = refreshBtnRef?.current;

    if (refreshBtn) {
      return refreshBtn.parentNode.parentNode.parentNode.parentNode.parentNode
        .parentNode.parentNode;
    }

    return null;
  };

  const getDialogTitle = () => {
    let ret = carrierKeyValue[`${carrier}`];

    switch(carrier) {
      case 4:
        ret = 'Purolator International';
        break;

      case 11:
        ret = 'Purolator Canada';
        break;
    }

    return ret;
  };

  const isFormSubmittable = () => {
    let ret = isFormTouched;

    if (actionType === 'add' && mode === 2) {
      ret = !!authCodeState;
    }

    return ret;
  };

  const onFullscreen = (isFullscreen: boolean) => {
    const dialog = getDialogDom();

    setDetailDialogIsFullscreen(isFullscreen);

    if (dialog) {
      const width = detailDialogWidth(isFullscreen);

      dialog.style.width = `${width}px`;
    }
  };

  const onSelectStore = (store?: StringKAnyVPair) => {
    //console.log('s', store);
    store && setSelectedChannelAccountNum(store.channelAccountNum);
  };

  // const onMarkShipOnlyChange = (evt: any) => {
  //   setMarkShipOnly(evt.target.checked);
  // };

  // eslint-disable-next-line
  const onUpsModeChange = (mode: number) => {
    setMode(mode);
    //console.log('m', mode);

    if (mode === 2) {
      checkUpsAuthCode();
    }
  };

  const onSandboxChange = (evt: any) => {
    setUseSandbox(evt.target.checked);
  };

  const getAccountInfo = useCallback(async () => {
    if (!accountInfo) return;
    try {
      setLoading(true);
      const res = await getShipAccountById(accountInfo.shipAccountNum);
      setLoading(false);
      if (res.isSuccess) {
        setInfo(res.data);
        //setMode(res.data.mode);
        res.data && res.data.sandBox && setUseSandbox(true);
        setMode(carrier === 8 ? 1 : res.data.mode);
        setSelectedProviderAccount(
          res.data?.shipingProviderAccountInfo?.shippingProviderAccountNum
        );
        setUseProviderAccount(
          res.data.shipingProviderAccountInfo ? 1 : res.data.channelFulfillmentAccountNum ? 2 : 0
        );
      } else {
        message.error({ content: res.message });
      }
    } catch (error) {
      setLoading(false);
    }
  }, [accountInfo, carrier]);

  const fetchAddressBook = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getAddressList();
      setLoading(false);
      if (res.isSuccess) {
        setAddressBook(res.data);
        setSelectedAddress((prev) => {
          const temp = res.data.filter(
            (i: AddressRow) => i.addressNum === prev?.addressNum
          );
          if (temp.length > 0) {
            return temp[0];
          } else {
            return undefined;
          }
        });
      }
    } catch (error) {
      setLoading(false);
    }
  }, []);

  // eslint-disable-next-line
  const getModeOptions = () => {
    const opts = [
      { label: 'Web Service', value: 0 },
      { label: 'Rest Api', value: 1 },
    ]; 

    if (props.carrier === 2) opts.push({ label: 'AuthCode', value: 2 });
    if ([7, 8, 9, 10].indexOf(props.carrier) > -1) opts.splice(0, 1);

    return opts;
  };

  const getProviderAccountInfo = useCallback(
    async (accountNum: number, carrierNum: number) => {
      form.setFieldsValue({ CarrierAccountNum: undefined });
      try {
        const res = await getShippingProviderAccountsCarrierInfo(
          accountNum,
          carrierNum
        );
        if (res.isSuccess) {
          setCarrierAccounts(res.data);
        }
      } catch (error) {
        return undefined;
      }
    },
    [form]
  );

  useEffect(() => {
    if (selectedProviderAccount) {
      getProviderAccountInfo(selectedProviderAccount, carrier);
    }
  }, [selectedProviderAccount, carrier, getProviderAccountInfo]);
  //   account
  // :
  // "276258362"
  // billingType
  // :
  // "carrier"
  // carrierType
  // :
  // "FedexAccount"
  // id
  // :
  // "ca_6a079a0672464c1ca1b34a80fc5e52ad"
  // name
  // :
  // "FedEx"

  const handleCreate = async () => {
    const params = await form.validateFields();
    console.log(params);
    if (params.errorFields) return;
    const WarehouseNums: any[] = [];
    warehouses.map((i) => {
      if (
        (params.shipIds || []).indexOf(i.id) > -1 ||
        (params.returnIds || []).indexOf(i.id) > -1
      )
        WarehouseNums.push({
          WarehouseNum: i.id,
          Ship: (params.shipIds || []).indexOf(i.id) > -1 ? 1 : 0,
          Return: (params.returnIds || []).indexOf(i.id) > -1 ? 1 : 0,
        });
      return true;
    });
    if (WarehouseNums.length === 0)
      return message.warning({
        content: 'At least one warehouse must be checked.',
      });
    setSaveLoading(true);
    try {
      let res: any = null;
      let providerInfo: any = undefined;
      if (useProviderAccount && params.CarrierAccountNum) {
        const temp = carrierAccounts.filter(
          (item) => item.id === params.CarrierAccountNum
        );
        if (temp.length > 0) {
          providerInfo = temp[0];
        }
      }
      switch (carrierKeyValue[`${carrier}`]) {
        case 'FedEx':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            // WarehouseNum: params.Common_WarehouseNum.warehouseNum,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            FedexAccountInfo: useProviderAccount === 0
              ? {
                Account: params.FedEx_Account,
                Password:
                  params.FedEx_Password === '******'
                    ? null
                    : params.FedEx_Password,
                MeterNum: '',
                Key: params.FedEx_Key === '******' ? null : params.FedEx_Key,
                HubId: params.FedEx_HubId,
              }: undefined,
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
            Mode: params.FedEx_Mode,
            ShipingProviderAccountInfo: useProviderAccount === 1
              ? {
                ShippingProviderAccountNum: params.ShippingProviderAccountNum,
                Name: params.Common_AccountNickname,
                Account: providerInfo.id,
                UserName: providerInfo.name,
                SandBox: params.Common_SandBox ? 1 : 0,
                Mode: params.FedEx_Mode,
              }
              : undefined,
            ChannelFulfillmentAccountNum: useProviderAccount === 2 ? params.ChannelFulfillmentAccountNum : undefined,
          });
          break;
        case 'UPS':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            UPSAccountInfo: useProviderAccount === 0
              ? {
                LicenseNumber: params.UPS_Mode === 0 ? params.UPS_License : '#',
                UserId: params.UPS_User_ID,
                Password:
                  params.UPS_Password === '******'
                    ? null
                    : params.UPS_Password,
                ShipperNumber: params.UPS_Shipper,
                ServiceDescription: params.UPS_Service_Dsecription,
              } : undefined,
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
            Mode: params.UPS_Mode,
            // @ts-ignore
            State: authCodeState,
            ShipingProviderAccountInfo: useProviderAccount === 1
              ? {
                ShippingProviderAccountNum: params.ShippingProviderAccountNum,
                Name: params.Common_AccountNickname,
                Account: providerInfo.id,
                UserName: providerInfo.name,
              }
              : undefined,
            ChannelFulfillmentAccountNum: useProviderAccount === 2 ? params.ChannelFulfillmentAccountNum : undefined,
          });
          break;
        case 'USPS':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            USPSAccountInfo: useProviderAccount === 0
              ? {
                Username: params.USPS_User_Name,
                Password:
                  params.USPS_Password === '******'
                    ? null
                    : params.USPS_Password,
                IntegrationID: params.USPS_Integration_ID,
              } : undefined,
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
            ShipingProviderAccountInfo: useProviderAccount ===1
              ? {
                ShippingProviderAccountNum: params.ShippingProviderAccountNum,
                Name: params.Common_AccountNickname,
                Account: providerInfo.id,
                UserName: providerInfo.name,
              }
              : undefined,
            ChannelFulfillmentAccountNum: useProviderAccount === 2 ? params.ChannelFulfillmentAccountNum : undefined,
          });
          break;
        case 'Purolator':
        case 'PurolatorCanada':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            PurolatorAccountInfo: useProviderAccount === 0 ? {
              ClientID: params.Purolator_ClientID,
              Username: params.Purolator_UserName,
              Password:
                params.Purolator_Password === '******'
                  ? null
                  : params.Purolator_Password,
            } : undefined,
            ShipingProviderAccountInfo: useProviderAccount === 1 ? {
              //Account: params.CarrierAccountNum,
              Account: providerInfo.id,
              Name: params.Common_AccountNickname,
              ShippingProviderAccountNum: params.ShippingProviderAccountNum,
              UserName: providerInfo.name,

            } : undefined,
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
          });
          break;
        case 'DHL':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
            ShipingProviderAccountInfo: {
              ShippingProviderAccountNum: params.ShippingProviderAccountNum,
              Name: params.Common_AccountNickname,
              Account: providerInfo.id,
              UserName: providerInfo.name,
            }
          });
          break;
        case 'Others':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            OthersAccountInfo: {
              Username: params.Other_Customer,
              Phone: params.Others_Phone,
              Note: params.Others_note,
            },
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
          });
          break;
        case 'Temu':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            TemuAccountInfo: {
              WarehouseCode: params.Temu_WarehouseCode,
              ApiCode: params.Temu_Code,
              TenantId: params.Temu_TenantId,
              ClientId: params.Temu_ClientId,
              ClientSecret: params.Temu_ClientSecre === '******' ? null : params.Temu_ClientSecre,

            },
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
          });
          break;
          case 'CanadaPost':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            // @ts-ignore
            Currency: 'CAD',
            ShipAccountType: 1,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            CanadaPostAccountInfo: useProviderAccount === 0
              ? {
                CustomerNumber: params.CanadaPost_CustomerNumber,
                UserId: params.CanadaPost_UserId,
                Password: params.CanadaPost_Password,
                ContractNumber: params.CanadaPost_ContractNumber,
                ShippingPoint: params.CanadaPost_ShippingPoint,
              } : undefined,
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
            Mode: params.CanadaPost_Mode,
            // @ts-ignore
            State: authCodeState,
            ShipingProviderAccountInfo: useProviderAccount === 1
              ? {
                ShippingProviderAccountNum: params.ShippingProviderAccountNum,
                Name: params.Common_AccountNickname,
                Account: providerInfo.id,
                UserName: providerInfo.name,
              }
              : undefined,
            ChannelFulfillmentAccountNum: useProviderAccount === 2 ? params.ChannelFulfillmentAccountNum : undefined,
          });
          break;

        case 'Amazon':
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            // WarehouseNum: params.Common_WarehouseNum.warehouseNum,
            // WarehouseNums: params.Common_WarehouseNums.map((item: number) => {
            //   return { WarehouseNum: item };
            // }),
            WarehouseNums,
            AccountUsage: params.Common_AccountUsage,
            // @ts-ignore
            AmazonAccountInfo: useProviderAccount === 0
              ? {
                Account: '',
                Password:
                  params.FedEx_Password === '******'
                    ? null
                    : ''/*params.FedEx_Password*/,
                MeterNum: '',
                Key: params.FedEx_Key === '******' ? null : ''/*params.FedEx_Key*/,
                HubId: ''/*params.FedEx_HubId*/,
              }: undefined,
            AddressNum: params.FromAddressNum,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
            Mode: params.FedEx_Mode,
            ShipingProviderAccountInfo: useProviderAccount === 1
              ? {
                ShippingProviderAccountNum: params.ShippingProviderAccountNum,
                Name: params.Common_AccountNickname,
                Account: providerInfo.id,
                UserName: providerInfo.name,
                SandBox: params.Common_SandBox ? 1 : 0,
                Mode: params.FedEx_Mode,
              }
              : undefined,
            ChannelFulfillmentAccountNum: useProviderAccount === 2 ? params.ChannelFulfillmentAccountNum : undefined,
          });
          break;

        case 'Shein':
        case 'Shein MktVendor':
          //console.log('pa', params);
          res = await SetShipAccount({
            ShipAccountNum: actionType === 'add' ? 0 : info?.shipAccountNum,
            CarrierNum: carrier,
            Status: 1,
            Name: params.Common_AccountNickname,
            ShipAccountType: 1,
            WarehouseNums,
            //AccountUsage: 0,
            AccountUsage: params.Common_AccountUsage,
            // @ts-ignore
            sheinAccountInfo: {
              Account: actionType === 'add' ? params.Carrier_Warehouse.value : info?.account,
            },
            AddressNum: params.FromAddressNum,
            //"NotToChannelAccount": 0,
            //"SandBox":1,
            NotToChannelAccount: params.Common_NotToChannelAccount ? 1 : 0,
            SandBox: params.Common_SandBox ? 1 : 0,
          });
          break;
      }
      setSaveLoading(false);
      if (res.isSuccess) {
        message.success({
          content:
            actionType === 'add'
              ? 'Add ShipAccount successful'
              : 'Save ShipAccount successful',
        });
        props.onClose(true);
      } else {
        message.error({ content: res.message });
      }
    } catch (error) {
      setSaveLoading(false);
    }
  };

  // eslint-disable-next-line
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 14 },
  };

  const getForm = useCallback(() => {
    return (
      <Form
        {...layout}
        form={form}
        onFieldsChange={() => setIsFormTouched(true)}
      >
        {carrierKeyValue[`${carrier}`] === 'FedEx' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      <Select.Option value={0}>
                        Ship And Bill Third Party
                      </Select.Option>
                      <Select.Option value={1}>Ship Only</Select.Option>
                      <Select.Option value={2}>
                        Bill to Third Party Only
                      </Select.Option>
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 ||
                              i.warehouseType === 5 ||
                              i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={(info?.warehouses || [])
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={(info?.warehouses || [])
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                {/* <Col span={12}>
                <Form.Item
                  name="Common_WarehouseNums"
                  initialValue={
                    info
                      ? info.warehouseNums.filter((i: number) => i !== 0)
                      : undefined
                  }
                  label={<FormLabel>Warehouse </FormLabel>}
                  rules={[
                    { required: true, message: 'please select warehouse' },
                  ]}
                >
                  <Select
                    id="Common_WarehouseNums"
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select"
                  >
                    {warehouses
                      .filter((i) => (i.warehouseType === 1 || i.warehouseType === 5))
                      .map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.code}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col> */}
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                headStyle={{ justifyContent: 'center', alignContent: 'center' }}
                title={
                  <Space>
                    {
                      <Image
                        preview={false}
                        width={90}
                        src={FedexIcon}
                        alt="FedEx"
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                }
              >
                <Row justify="center" style={{ marginBottom: 8 }}>
                  <Radio.Group
                    value={useProviderAccount}
                    buttonStyle="solid"
                    onChange={(e) => setUseProviderAccount(e.target.value)}
                  >
                    <Radio.Button disabled={info} value={0}>
                      FedEx Account
                    </Radio.Button>
                    <Radio.Button disabled={info} value={1}>
                      Provider Account
                    </Radio.Button>
                    <Radio.Button disabled={info} value={2}>
                      Channel Fulfillment
                    </Radio.Button>
                  </Radio.Group>
                </Row>
                {useProviderAccount ===1 ? (
                  <>
                    <Form.Item
                      name="ShippingProviderAccountNum"
                      initialValue={
                        info?.shipingProviderAccountInfo
                          ?.shippingProviderAccountNum
                      }
                      label={<FormLabel>Provider Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select provider account!',
                        },
                      ]}
                    >
                      <Select onChange={setSelectedProviderAccount}>
                        {providerAccounts.map((item: any) => (
                          <Select.Option
                            key={item.shippingProviderAccountNum}
                            value={item.shippingProviderAccountNum}
                          >
                            {`${item.name} (${item.account})`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="CarrierAccountNum"
                      initialValue={info?.shipingProviderAccountInfo?.account}
                      label={<FormLabel>Carrier Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select carrier account!',
                        },
                      ]}
                    >
                      <Select disabled={!selectedProviderAccount}>
                        {carrierAccounts.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                          >{`${item.name}-${item.account} (${item.id})`}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : useProviderAccount === 2 ? (
                  <>
                    <Form.Item
                      name="ChannelFulfillmentAccountNum"
                      initialValue={
                        info?.channelFulfillmentAccountNum        
                      }
                      label={<FormLabel>Account</FormLabel>}
                      rules={[
                        {
                          required: true,
                          message: 'Please select account!',
                        },
                      ]}
                    >
                      <Select>
                        {channelfulfillments.map((item: any) => (
                          <Select.Option
                            key={item.channelFulfillmentAccountNum}
                            value={item.channelFulfillmentAccountNum}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : (
                  <>
                    <Form.Item
                      name="FedEx_Mode"
                      initialValue={info?.mode || 0}
                      label={<FormLabel>Mode</FormLabel>}
                    >
                      <Select
                        onChange={e => setMode(e)}
                        options={getModeOptions()}
                      />
                    </Form.Item>
                    <Form.Item
                      name="FedEx_Account"
                      initialValue={info?.account}
                      label={<FormLabel>FedEx Account No</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input FedEx Account No!',
                        },
                      ]}
                    >
                      <Input id="FedEx_Account" />
                    </Form.Item>
                    <Form.Item
                      name="FedEx_Key"
                      initialValue={info ? '******' : undefined}
                      label={<FormLabel>{mode === 0 ? 'Key' : 'App Id'}</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Key!',
                        },
                      ]}
                    >
                      <Input id="FedEx_Key" />
                    </Form.Item>
                    <Form.Item
                      name="FedEx_Password"
                      initialValue={info ? '******' : undefined}
                      label={<FormLabel>{mode === 0 ? 'Password' : 'App Secret'}</FormLabel>}
                      rules={[
                        { required: selectedUsage !==3, message: 'Please input password!' },
                      ]}
                    >
                      <Input id="FedEx_Password" type="password" />
                    </Form.Item>
                    {/* <Form.Item
                      name="FedEx_Meter"
                      initialValue={info?.meterNum}
                      label={<FormLabel>Meter #</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Meter!',
                        },
                      ]}
                    >
                      <Input id="FedEx_Meter" />
                    </Form.Item> */}
                    <Form.Item
                      name="FedEx_HubId"
                      initialValue={info?.hubId}
                      label={<FormLabel>Hub ID</FormLabel>}
                    >
                      <Input id="FedEx_HubId" />
                    </Form.Item>
                  </>
                )}
              </Card>
            </TwoCol>
          </>
        )}

        {carrierKeyValue[`${carrier}`] === 'UPS' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      <Select.Option value={0}>
                        Ship And Bill Third Party
                      </Select.Option>
                      <Select.Option value={1}>Ship Only</Select.Option>
                      <Select.Option value={2}>
                        Bill to Third Party Only
                      </Select.Option>
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Space>
                    {
                      <Image
                        preview={false}
                        width={90}
                        src={UPSIcon}
                        alt="UPS"
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                }
              >
                <Row justify="center" style={{ marginBottom: 8 }}>
                  <Radio.Group
                    value={useProviderAccount}
                    buttonStyle="solid"
                    onChange={(e) => setUseProviderAccount(e.target.value)}
                  >
                    <Radio.Button disabled={info} value={0}>
                      UPS Account
                    </Radio.Button>
                    <Radio.Button disabled={info} value={1}>
                      Provider Account
                    </Radio.Button>
                    <Radio.Button disabled={info} value={2}>
                      Channel Fulfillment
                    </Radio.Button>
                  </Radio.Group>
                </Row>
                {useProviderAccount === 1 ? (
                  <>
                    <Form.Item
                      name="ShippingProviderAccountNum"
                      initialValue={
                        info?.shipingProviderAccountInfo
                          ?.shippingProviderAccountNum
                      }
                      label={<FormLabel>Provider Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select provider account!',
                        },
                      ]}
                    >
                      <Select onChange={setSelectedProviderAccount}>
                        {providerAccounts.map((item: any) => (
                          <Select.Option
                            key={item.shippingProviderAccountNum}
                            value={item.shippingProviderAccountNum}
                          >
                            {`${item.name} (${item.account})`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="CarrierAccountNum"
                      initialValue={info?.shipingProviderAccountInfo?.account}
                      label={<FormLabel>Carrier Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select carrier account!',
                        },
                      ]}
                    >
                      <Select disabled={!selectedProviderAccount}>
                        {carrierAccounts.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                          >{`${item.name}-${item.account} (${item.id})`}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : useProviderAccount === 2 ? (<>
                    <Form.Item
                      name="ChannelFulfillmentAccountNum"
                      initialValue={
                        info?.channelFulfillmentAccountNum        
                      }
                      label={<FormLabel>Account</FormLabel>}
                      rules={[
                        {
                          required: true,
                          message: 'Please select account!',
                        },
                      ]}
                    >
                      <Select>
                        {channelfulfillments.map((item: any) => (
                          <Select.Option
                            key={item.channelFulfillmentAccountNum}
                            value={item.channelFulfillmentAccountNum}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                </>) : (
                  <>
                    <Form.Item
                      name="UPS_Mode"
                      initialValue={info?.mode || 0}
                      label={<FormLabel>Mode</FormLabel>}
                    >
                      <Select
                        onChange={onUpsModeChange}
                        options={getModeOptions()}
                      />
                    </Form.Item>
                    {mode===0 && <Form.Item
                      name="UPS_License"
                      initialValue={info?.licenseNumber}
                      label={<FormLabel>License #</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input License!',
                        },
                      ]}
                    >
                      <Input id="UPS_License" />
                    </Form.Item>}
                    {mode !== 2 && <Form.Item
                      name="UPS_User_ID"
                      initialValue={info?.userId}
                      label={<FormLabel>{mode === 0 ? 'User ID' : 'Client Id'}</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: mode === 0 ? 'Please input User ID!' : 'Please input Client Id!',
                        },
                      ]}
                    >
                      <Input id="UPS_User_ID" />
                    </Form.Item>}
                    {mode !== 2 && <Form.Item
                      name="UPS_Password"
                      initialValue={info ? '******' : undefined}
                      label={<FormLabel>{mode===0 ? 'Password': 'Client Secret'}</FormLabel>}
                      rules={[
                        { required: selectedUsage !==3, message: mode===0? 'Please input password!': 'Please input client secret!' },
                      ]}
                    >
                      <Input id="UPS_Password" type="password" />
                    </Form.Item>}

                    <Form.Item
                      name="UPS_Shipper"
                      initialValue={info?.shipperNumber}
                      label={<FormLabel>Shipper #</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Shipper!',
                        },
                      ]}
                    >
                      <Input id="UPS_Shipper" />
                    </Form.Item>
                    <Form.Item
                      name="UPS_Service_Dsecription"
                      initialValue={info?.serviceDescription}
                      label={<FormLabel>Service Dsecription</FormLabel>}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: 'Please input Service Dseription!',
                    //   },
                    // ]}
                    >
                      <Input id="UPS_Service_Dsecription" />
                    </Form.Item>
                    {(actionType === 'edit' && mode === 2) && <Row>
                      <Col span={8} style={{textAlign: 'right'}}>
                        <Button onClick={checkUpsAuthCode}>Re-Authorize</Button>
                      </Col>
                    </Row>}
                  </>
                )}
              </Card>
            </TwoCol>
          </>
        )}

        {carrierKeyValue[`${carrier}`] === 'USPS' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      {/* <Select.Option value={0}>
                      Ship And Bill Third Party
                    </Select.Option> */}
                      <Select.Option value={1}>Ship Only</Select.Option>
                      {/* <Select.Option value={2}>Bill Third Party Only</Select.Option>  */}
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>{' '}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Space>
                    {
                      <Image
                        preview={false}
                        width={90}
                        src={USPSIcon}
                        alt="USPS"
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                }
              >
                <Row justify="center" style={{ marginBottom: 8 }}>
                  <Radio.Group
                    value={useProviderAccount}
                    buttonStyle="solid"
                    onChange={(e) => setUseProviderAccount(e.target.value)}
                  >
                    <Radio.Button disabled={info} value={0}>
                      USPS Account
                    </Radio.Button>
                    <Radio.Button disabled={info} value={1}>
                      Provider Account
                    </Radio.Button>
                    <Radio.Button disabled={info} value={2}>
                      Channel Fulfillment
                    </Radio.Button>
                  </Radio.Group>
                </Row>
                {useProviderAccount === 1 ? (
                  <>
                    <Form.Item
                      name="ShippingProviderAccountNum"
                      initialValue={
                        info?.shipingProviderAccountInfo
                          ?.shippingProviderAccountNum
                      }
                      label={<FormLabel>Provider Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !== 3,
                          message: 'Please select provider account!',
                        },
                      ]}
                    >
                      <Select onChange={setSelectedProviderAccount}>
                        {providerAccounts.map((item: any) => (
                          <Select.Option
                            key={item.shippingProviderAccountNum}
                            value={item.shippingProviderAccountNum}
                          >
                            {`${item.name} (${item.account})`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="CarrierAccountNum"
                      initialValue={info?.shipingProviderAccountInfo?.account}
                      label={<FormLabel>Carrier Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !== 3,
                          message: 'Please select carrier account!',
                        },
                      ]}
                    >
                      <Select disabled={ !selectedProviderAccount}>
                        {carrierAccounts.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                          >{`${item.name}-${item.account} (${item.id})`}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : useProviderAccount === 2 ? (
                  <>
                    <Form.Item
                      name="ChannelFulfillmentAccountNum"
                      initialValue={
                        info?.channelFulfillmentAccountNum        
                      }
                      label={<FormLabel>Account</FormLabel>}
                      rules={[
                        {
                          required: true,
                          message: 'Please select account!',
                        },
                      ]}
                    >
                      <Select>
                        {channelfulfillments.map((item: any) => (
                          <Select.Option
                            key={item.channelFulfillmentAccountNum}
                            value={item.channelFulfillmentAccountNum}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : (
                  <>
                    <Form.Item
                      name="USPS_User_Name"
                      initialValue={info?.username}
                      label={<FormLabel>User Name</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !== 3,
                          message: 'Please input User Name!',
                        },
                      ]}
                    >
                      <Input id="USPS_User_Name"/>
                    </Form.Item>
                    <Form.Item
                      name="USPS_Password"
                      initialValue={info ? '******' : undefined}
                      label={<FormLabel>Password</FormLabel>}
                      rules={[
                        { required: selectedUsage !== 3, message: 'Please input password!' },
                      ]}
                    >
                      <Input id="USPS_Password" type="password" />
                    </Form.Item>
                    <Form.Item
                      name="USPS_Integration_ID"
                      initialValue={info?.integrationID}
                      label={<FormLabel>Integration ID</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !== 3,
                          message: 'Please input Integration ID!',
                        },
                      ]}
                    >
                      <Input id="USPS_Integration_ID" />
                    </Form.Item>
                  </>
                )}
              </Card>
            </TwoCol>
          </>
        )}

        {/*carrierKeyValue[`${carrier}`] === 'Purolator' && (*/}
        {[4, 11].indexOf(carrier) > -1 && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      {/* <Select.Option value={0}>
                      Ship And Bill Third Party
                    </Select.Option> */}
                      <Select.Option value={1}>Ship Only</Select.Option>
                      {/* <Select.Option value={2}>Bill Third Party Only</Select.Option>  */}
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>{' '}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_adress_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Space>
                    {
                      <Image
                        preview={false}
                        width={90}
                        src={Purolator}
                        alt="Purolator"
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                }
              >
                <Row justify="center" style={{ marginBottom: 8 }}>
                  <Radio.Group
                    value={useProviderAccount}
                    buttonStyle="solid"
                    onChange={(e) => setUseProviderAccount(e.target.value)}
                  >
                    <Radio.Button disabled={info} value={0}>
                      Purolator Account
                    </Radio.Button>
                    {carrier === 4 && <Radio.Button disabled={info} value={1}>
                      Provider Account
                    </Radio.Button>}
                  </Radio.Group>
                </Row>
                {useProviderAccount === 0 && (<>
                <Form.Item
                  name="Purolator_ClientID"
                  initialValue={info?.clientID}
                  label={<FormLabel>Account</FormLabel>}
                  rules={[
                    {
                      required: selectedUsage !== 3,
                      message: 'Please input the account!',
                    },
                  ]}
                >
                  <Input id="Purolator_ClientID" />
                </Form.Item>

                <Form.Item
                  name="Purolator_UserName"
                  initialValue={info?.username}
                  label={<FormLabel>Key</FormLabel>}
                  rules={[
                    {
                      required: selectedUsage !== 3,
                      message: 'Please input the key!',
                    },
                  ]}
                >
                  <Input id="Purolator_UserName" />
                </Form.Item>
                <Form.Item
                  name="Purolator_Password"
                  initialValue={info ? '******' : undefined}
                  label={<FormLabel>Password</FormLabel>}
                  rules={[
                    { required: selectedUsage !== 3, message: 'Please input password!' },
                  ]}
                >
                  <Input id="Purolator_Password" type="password"/>
                </Form.Item>
                </>)}
                {useProviderAccount === 1 && (<>
                  <Form.Item
                    name="ShippingProviderAccountNum"
                    initialValue={
                      info?.shipingProviderAccountInfo
                        ?.shippingProviderAccountNum
                    }
                    label={<FormLabel>Provider Account</FormLabel>}
                    rules={[
                      {
                        required: selectedUsage !==3,
                        message: 'Please select provider account!',
                      },
                    ]}
                  >
                    <Select onChange={setSelectedProviderAccount}>
                      {providerAccounts.map((item: any) => (
                        <Select.Option
                          key={item.shippingProviderAccountNum}
                          value={item.shippingProviderAccountNum}
                        >
                          {`${item.name} (${item.account})`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="CarrierAccountNum"
                    initialValue={info?.shipingProviderAccountInfo?.account}
                    label={<FormLabel>Carrier Account</FormLabel>}
                    rules={[
                      {
                        required: selectedUsage !==3,
                        message: 'Please select carrier account!',
                      },
                    ]}
                  >
                    <Select disabled={!selectedProviderAccount}>
                      {carrierAccounts.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                        >{`${item.name}-${item.account} (${item.id})`}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>)}
              </Card>
            </TwoCol>
          </>
        )}

        {carrierKeyValue[`${carrier}`] === 'DHL' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      <Select.Option value={0}>
                        Ship And Bill Third Party
                      </Select.Option>
                      <Select.Option value={1}>Ship Only</Select.Option>
                      <Select.Option value={2}>
                        Bill to Third Party Only
                      </Select.Option>
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 ||
                              i.warehouseType === 5 ||
                              i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={(info?.warehouses || [])
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={(info?.warehouses || [])
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                headStyle={{ justifyContent: 'center', alignContent: 'center' }}
                title={
                  <Space>
                    {
                      <Image
                        preview={false}
                        width={90}
                        src={DHLIcon}
                        alt="DHL"
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                }
              >
                <>
                  <Form.Item
                    name="ShippingProviderAccountNum"
                    initialValue={
                      info?.shipingProviderAccountInfo
                        ?.shippingProviderAccountNum
                    }
                    label={<FormLabel>Provider Account</FormLabel>}
                    rules={[
                      {
                        required: selectedUsage !== 3,
                        message: 'Please select provider account!',
                      },
                    ]}
                  >
                    <Select onChange={setSelectedProviderAccount}>
                      {providerAccounts.map((item: any) => (
                        <Select.Option
                          key={item.shippingProviderAccountNum}
                          value={item.shippingProviderAccountNum}
                        >
                          {`${item.name} (${item.account})`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="CarrierAccountNum"
                    initialValue={info?.shipingProviderAccountInfo?.account}
                    label={<FormLabel>Carrier Account</FormLabel>}
                    rules={[
                      {
                        required: selectedUsage !== 3,
                        message: 'Please select carrier account!',
                      },
                    ]}
                  >
                    <Select disabled={!selectedProviderAccount}>
                      {carrierAccounts.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                        >{`${item.name}-${item.account} (${item.id})`}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              </Card>
            </TwoCol>
          </>
        )}

        {carrierKeyValue[`${carrier}`] === 'CanadaPost' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      <Select.Option value={0}>
                        Ship And Bill Third Party
                      </Select.Option>
                      <Select.Option value={1}>Ship Only</Select.Option>
                      <Select.Option value={2}>
                        Bill to Third Party Only
                      </Select.Option>
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Space>
                    {
                      <CanadaPostSVG
                        width={36}
                        height={36}
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                }
              >
                <Row justify="center" style={{ marginBottom: 8 }}>
                  <Radio.Group
                    value={useProviderAccount}
                    buttonStyle="solid"
                    onChange={(e) => setUseProviderAccount(e.target.value)}
                  >
                    <Radio.Button disabled={info} value={0}>
                      Canada Post Account
                    </Radio.Button>
                    <Radio.Button disabled={info} value={1}>
                      Provider Account
                    </Radio.Button>
                    {/*<Radio.Button disabled={info} value={2}>
                      Channel Fulfillment
                    </Radio.Button>*/}
                  </Radio.Group>
                </Row>
                {useProviderAccount === 1 ? (
                  <>
                    <Form.Item
                      name="ShippingProviderAccountNum"
                      initialValue={
                        info?.shipingProviderAccountInfo
                          ?.shippingProviderAccountNum
                      }
                      label={<FormLabel>Provider Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select provider account!',
                        },
                      ]}
                    >
                      <Select onChange={setSelectedProviderAccount}>
                        {providerAccounts.map((item: any) => (
                          <Select.Option
                            key={item.shippingProviderAccountNum}
                            value={item.shippingProviderAccountNum}
                          >
                            {`${item.name} (${item.account})`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="CarrierAccountNum"
                      initialValue={info?.shipingProviderAccountInfo?.account}
                      label={<FormLabel>Carrier Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select carrier account!',
                        },
                      ]}
                    >
                      <Select disabled={!selectedProviderAccount}>
                        {carrierAccounts.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                          >{`${item.name}-${item.account} (${item.id})`}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : useProviderAccount === 2 ? (<>
                    <Form.Item
                      name="ChannelFulfillmentAccountNum"
                      initialValue={
                        info?.channelFulfillmentAccountNum        
                      }
                      label={<FormLabel>Account</FormLabel>}
                      rules={[
                        {
                          required: true,
                          message: 'Please select account!',
                        },
                      ]}
                    >
                      <Select>
                        {channelfulfillments.map((item: any) => (
                          <Select.Option
                            key={item.channelFulfillmentAccountNum}
                            value={item.channelFulfillmentAccountNum}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                </>) : (
                  <>
                    <Form.Item
                      name="CanadaPost_Mode"
                      initialValue={info?.mode || 1}
                      label={<FormLabel>Mode</FormLabel>}
                    >
                      <Select
                        onChange={e => setMode(e)}
                        options={getModeOptions()}
                      />
                    </Form.Item>
                    <Form.Item
                      name="CanadaPost_CustomerNumber"
                      initialValue={info?.account}
                      label={<FormLabel>Customer Number</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Customer Number!',
                        },
                      ]}
                    >
                      <Input id="CanadaPost_CustomerNumber" />
                    </Form.Item>
                    <Form.Item
                      name="CanadaPost_UserId"
                      //initialValue={info ? '******' : undefined}
                      initialValue={info?.userId}
                      label={<FormLabel>{mode === 0 ? 'Key' : 'User Name'}</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input User Name!',
                        },
                      ]}
                    >
                      <Input id="CanadaPost_UserId" />
                    </Form.Item>
                    <Form.Item
                      name="CanadaPost_Password"
                      initialValue={info ? '******' : undefined}
                      label={<FormLabel>{mode === 0 ? 'Password' : 'Password'}</FormLabel>}
                      rules={[
                        { required: selectedUsage !==3, message: 'Please input password!' },
                      ]}
                    >
                      <Input id="CanadaPost_Password" type="password" />
                    </Form.Item>
                    <Form.Item
                      name="CanadaPost_ContractNumber"
                      initialValue={info?.contractNumber}
                      label={<FormLabel>Contract Number</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Contract Number!',
                        },
                      ]}
                    >
                      <Input id="CanadaPost_ContractNumber" />
                    </Form.Item>
                    <Form.Item
                      name="CanadaPost_ShippingPoint"
                      initialValue={info?.shippingPoint}
                      label={<FormLabel>Shipping Point</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Shipping Point!',
                        },
                      ]}
                    >
                      <Input id="CanadaPost_ShippingPoint" />
                    </Form.Item>
                  </>
                )}
              </Card>
            </TwoCol>
          </>
        )}

        {carrierKeyValue[`${carrier}`] === 'Amazon' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      <Select.Option value={0}>
                        Ship And Bill Third Party
                      </Select.Option>
                      <Select.Option value={1}>Ship Only</Select.Option>
                      <Select.Option value={2}>
                        Bill to Third Party Only
                      </Select.Option>
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    //initialValue={info?.sandBox ? true : false}
                    initialValue={true}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox" disabled>
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Row align="middle">
                  <Space>
                    {
                      <AmazonSvg
                        width={100}
                        height={50}
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                  </Row>
                }
              >
                <Row justify="center" style={{ marginBottom: 8 }}>
                  <Radio.Group
                    value={useProviderAccount}
                    buttonStyle="solid"
                    onChange={(e) => setUseProviderAccount(e.target.value)}
                  >
                    <Radio.Button disabled={info} value={0}>
                      Amazon Account
                    </Radio.Button>
                    {/*<Radio.Button disabled={info} value={1}>
                      Provider Account
                    </Radio.Button>*/}
                    {/*<Radio.Button disabled={info} value={2}>
                      Channel Fulfillment
                    </Radio.Button>*/}
                  </Radio.Group>
                </Row>
                {useProviderAccount === 1 ? (
                  <>
                    <Form.Item
                      name="ShippingProviderAccountNum"
                      initialValue={
                        info?.shipingProviderAccountInfo
                          ?.shippingProviderAccountNum
                      }
                      label={<FormLabel>Provider Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select provider account!',
                        },
                      ]}
                    >
                      <Select onChange={setSelectedProviderAccount}>
                        {providerAccounts.map((item: any) => (
                          <Select.Option
                            key={item.shippingProviderAccountNum}
                            value={item.shippingProviderAccountNum}
                          >
                            {`${item.name} (${item.account})`}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="CarrierAccountNum"
                      initialValue={info?.shipingProviderAccountInfo?.account}
                      label={<FormLabel>Carrier Account</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please select carrier account!',
                        },
                      ]}
                    >
                      <Select disabled={!selectedProviderAccount}>
                        {carrierAccounts.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                          >{`${item.name}-${item.account} (${item.id})`}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                ) : useProviderAccount === 2 ? (<>
                    <Form.Item
                      name="ChannelFulfillmentAccountNum"
                      initialValue={
                        info?.channelFulfillmentAccountNum        
                      }
                      label={<FormLabel>Account</FormLabel>}
                      rules={[
                        {
                          required: true,
                          message: 'Please select account!',
                        },
                      ]}
                    >
                      <Select>
                        {channelfulfillments.map((item: any) => (
                          <Select.Option
                            key={item.channelFulfillmentAccountNum}
                            value={item.channelFulfillmentAccountNum}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                </>) : (
                   <>
                    <Form.Item
                      name="Fedex_Mode"
                      initialValue={info?.mode || 1}
                      label={<FormLabel>Mode</FormLabel>}
                    >
                      <Select
                        onChange={e => setMode(e)}
                        options={getModeOptions()}
                      />
                    </Form.Item>
                    {mode === 0 && (<>
                    <Form.Item
                      name="FedEx_Account"
                      initialValue={info?.account}
                      label={<FormLabel>Amazon Account No</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Amazon Account No!',
                        },
                      ]}
                    >
                      <Input id="FedEx_Account" />
                    </Form.Item>
                    <Form.Item
                      name="FedEx_Key"
                      initialValue={info ? '******' : undefined}
                      label={<FormLabel>{mode === 0 ? 'Key' : 'App Id'}</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Key!',
                        },
                      ]}
                    >
                      <Input id="FedEx_Key" />
                    </Form.Item>
                    <Form.Item
                      name="FedEx_Password"
                      initialValue={info ? '******' : undefined}
                      label={<FormLabel>{mode === 0 ? 'Password' : 'App Secret'}</FormLabel>}
                      rules={[
                        { required: selectedUsage !==3, message: 'Please input password!' },
                      ]}
                    >
                      <Input id="FedEx_Password" type="password" />
                    </Form.Item>
                    {/* <Form.Item
                      name="FedEx_Meter"
                      initialValue={info?.meterNum}
                      label={<FormLabel>Meter #</FormLabel>}
                      rules={[
                        {
                          required: selectedUsage !==3,
                          message: 'Please input Meter!',
                        },
                      ]}
                    >
                      <Input id="FedEx_Meter" />
                    </Form.Item> */}
                    <Form.Item
                      name="FedEx_HubId"
                      initialValue={info?.hubId}
                      label={<FormLabel>Hub ID</FormLabel>}
                    >
                      <Input id="FedEx_HubId" />
                    </Form.Item>
                    </>)}
                  </>
                )}
              </Card>
            </TwoCol>
          </>
        )}

        {['Shein', 'Shein MktVendor'].indexOf(carrierKeyValue[`${carrier}`]) > -1 && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      <Select.Option value={0}>
                        Ship And Bill Third Party
                      </Select.Option>
                      <Select.Option value={1}>Ship Only</Select.Option>
                      <Select.Option value={2}>
                        Bill to Third Party Only
                      </Select.Option>
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    //initialValue={true}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox" onChange={onSandboxChange}>
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Row align="middle">
                  <Space>
                    {carrier === 9 &&
                      <SheinSvg
                        width={100}
                        height={50}
                      />
                    }
                    {carrier === 10 &&
                      <img
                        alt="Shein MarketPlace Vendor"
                        height={50}
                        src="/imgs/SheinMarketplace.png"
                        style={{objectFit: 'contain'}}
                        width={100}
                      />
                    }
                    <span>Sign In Account Information</span>
                  </Space>
                  </Row>
                }
              >
                <Row justify="center" style={{ marginBottom: 8 }}>
                  <Radio.Group
                    value={useProviderAccount}
                    buttonStyle="solid"
                    onChange={(e) => setUseProviderAccount(e.target.value)}
                  >
                    <Radio.Button disabled={info} value={0}>
                      {carrierKeyValue[`${carrier}`]} Account
                    </Radio.Button>
                    {/*<Radio.Button disabled={info} value={1}>
                      Provider Account
                    </Radio.Button>*/}
                    {/*<Radio.Button disabled={info} value={2}>
                      Channel Fulfillment
                    </Radio.Button>*/}
                  </Radio.Group>
                </Row>
                {useProviderAccount === 1 ?  (<></>) : useProviderAccount === 2 ? (<>
                </>) : (
                   <>
                    <Form.Item
                      name="Fedex_Mode"
                      initialValue={info?.mode || 1}
                      label={<FormLabel>Mode</FormLabel>}
                    >
                      <Select
                        disabled={actionType === 'edit'}
                        onChange={e => setMode(e)}
                        options={getModeOptions()}
                      />
                    </Form.Item>
                    <Form.Item
                      name="Carrier_Store"
                      initialValue={info?.store || ''}
                      hidden={actionType === 'edit'}
                      label={<FormLabel>Store</FormLabel>}
                    >
                      <StoreSelector
                        onChange={onSelectStore}
                      />
                    </Form.Item>
                    <Form.Item
                      name="Carrier_Warehouse"
                      initialValue={info?.account || ''}
                      label={<FormLabel>Warehouse</FormLabel>}
                    >
                      <CarrierWarehouseSelector
                        carrierNum={carrier}
                        channelAccountNum={selectedChannelAccountNum || 0}
                        //sandbox={1}
                        sandbox={useSandbox ? 1 : 0}
                      />
                    </Form.Item>
                  </>
                )}
              </Card>
            </TwoCol>
          </>
        )}

        {carrierKeyValue[`${carrier}`] === 'Others' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      {/* <Select.Option value={0}>
                      Ship And Bill Third Party
                    </Select.Option> */}
                      <Select.Option value={1}>Ship Only</Select.Option>
                      {/* <Select.Option value={2}>Bill Third Party Only</Select.Option>  */}
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>{' '}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Space>
                    {
                      <Image
                        preview={false}
                        style={{ height: 50 }}
                        src={Other}
                        alt="Other"
                      />
                    }
                    <span>Account Information</span>
                  </Space>
                }
              >
                <Form.Item
                  name="Other_Customer"
                  initialValue={info?.username}
                  label={<FormLabel>Account No.</FormLabel>}
                // rules={[
                //   {
                //     required: true,
                //     message: 'Please input  Customer!',
                //   },
                // ]}
                >
                  <Input id="Other_Customer" />
                </Form.Item>

                <Form.Item
                  name="Others_Phone"
                  initialValue={info?.phone}
                  label={<FormLabel>Tel</FormLabel>}
                // rules={[
                //   {
                //     required: true,
                //     message: 'Please input contact number!',
                //   },
                // ]}
                >
                  <Input id="Others_Phone" />
                </Form.Item>
                <Form.Item
                  name="Others_note"
                  initialValue={info?.note}
                  label={<FormLabel>Note</FormLabel>}
                >
                  <Input />
                </Form.Item>
              </Card>
            </TwoCol>
          </>
        )}

        {carrierKeyValue[`${carrier}`] === 'Temu' && (
          <>
            <Card>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="Common_AccountNickname"
                    initialValue={info?.name}
                    label={<FormLabel>Name</FormLabel>}
                    rules={[{ required: true, message: 'please input Name' }]}
                  >
                    <Input id="Common_AccountNickname" />
                  </Form.Item>
                  <Form.Item
                    name="Common_AccountUsage"
                    initialValue={info?.accountUsage}
                    label={<FormLabel>Account Usage </FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'please select account usage',
                      },
                    ]}
                  >
                    <Select id="Common_AccountUsage" onChange={setSelectedUsage}>
                      {/* <Select.Option value={0}>
                      Ship And Bill Third Party
                    </Select.Option> */}
                      <Select.Option value={1}>Ship Only</Select.Option>
                      {/* <Select.Option value={2}>Bill Third Party Only</Select.Option>  */}
                      <Select.Option value={3}>
                        Mark Ship Only
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="Common_NotToChannelAccount"
                    initialValue={info?.notToChannelAccount ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_NotToChannelAccount">
                      Don't copy to Channel account
                    </Checkbox>
                  </Form.Item>
                  <Form.Item
                    name="Common_SandBox"
                    initialValue={info?.sandBox ? true : false}
                    valuePropName="checked"
                    label={<FormLabel noColon> </FormLabel>}
                  >
                    <Checkbox id="Common_SandBox">
                      SandBox
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Card
                    size="small"
                    title={
                      <Row>
                        <Col span={12}>Warehouse</Col>
                        <Col span={6}>Ship</Col>
                        <Col span={6}>Return</Col>
                      </Row>
                    }
                    bodyStyle={{ height: 100, overflowY: 'auto' }}
                  >
                    <Row>
                      <Col span={12}>
                        {warehouses
                          .filter(
                            (i) =>
                              i.warehouseType === 1 || i.warehouseType === 5
                          )
                          .map((item) => (
                            <Row id={item.code} key={item.code}>
                              <Typography.Text>{item.code}</Typography.Text>
                            </Row>
                          ))}
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="shipIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.ship)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_ship`}
                                  key={`${item.code}_ship`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="returnIds"
                          initialValue={info?.warehouses
                            .filter((i: any) => i.return)
                            .map((i: any) => i.warehouseNum)}
                        >
                          <Checkbox.Group style={{ width: '100%' }}>
                            {warehouses
                              .filter(
                                (i) =>
                                  i.warehouseType === 1 || i.warehouseType === 5
                              )
                              .map((item) => (
                                <Row
                                  id={`${item.code}_return`}
                                  key={`${item.code}_return`}
                                >
                                  <Checkbox value={item.id} />
                                </Row>
                              ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
            <TwoCol style={{ marginTop: COMMON_CARD_WRAPPER_MARGIN }}>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                bodyStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: 250,
                }}
                title="Contact Address"
              >
                <>
                  <Form.Item
                    name="FromAddressNum"
                    initialValue={info?.addressDto?.addressNum}
                    label={<FormLabel>Address</FormLabel>}
                    rules={[{ required: true, message: 'Address is required' }]}
                  // extra={
                  //   selectedAddress
                  //     ? `${selectedAddress?.contactName}, ${selectedAddress?.street1} ${selectedAddress?.street2} ${selectedAddress?.street3}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.postalCode}, ${selectedAddress?.country}`
                  //     : ''
                  // }
                  >
                    <Select
                      id="FromAddressNum"
                      optionLabelProp="label"
                      allowClear
                      onChange={(num) =>
                        setSelectedAddress(
                          addressBook.filter(
                            (item) => item.addressNum === Number(num)
                          )[0]
                        )
                      }
                    >
                      {addressBook.map((item) => (
                        <Select.Option
                          value={item.addressNum}
                          key={item.addressNum}
                          label={item.addressAlias}
                        >
                          <span>{`${item.addressAlias || ''} - ${item.contactName ? item.contactName + ',' : ''
                            } ${item.street1 || ''} ${item.street2 || ''} ${item.street3 ? item.street3 + ',' : ','
                            } ${item.city ? item.city + ',' : ''} ${item.state || ''
                            } ${item.postalCode ? item.postalCode + ',' : ','} ${item.country || ''
                            }`}</span>{' '}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {selectedAddress && (
                    <Form.Item label={<FormLabel noColon> </FormLabel>}>
                      <Space direction="vertical">
                        <Text>{selectedAddress.contactName || ''}</Text>
                        {selectedAddress.street1 && (
                          <Text>{selectedAddress.street1}</Text>
                        )}
                        {selectedAddress.street2 && (
                          <Text>{selectedAddress.street2}</Text>
                        )}
                        {selectedAddress.street3 && (
                          <Text>{selectedAddress.street3}</Text>
                        )}
                        <Text>{`${selectedAddress.city || ''}, ${selectedAddress.state || ''
                          } ${selectedAddress.postalCode || ''}`}</Text>
                        <Text>{selectedAddress.country || ''}</Text>
                      </Space>
                    </Form.Item>
                  )}
                </>
                <Space>
                  <Button
                    id="add_address_button"
                    onClick={() => {
                      setAddressAct('add');
                      setCreatelVisible(true);
                    }}
                  >
                    <PlusOutlined />
                    New Address
                  </Button>
                  <Button
                    id="edit_address_button"
                    disabled={!selectedAddress}
                    onClick={() => {
                      setAddressAct('edit');
                      setCreatelVisible(true);
                    }}
                  >
                    <EditOutlined />
                    Update Address
                  </Button>
                </Space>
              </Card>
              <Card
                size="small"
                style={{ minWidth: 500, width: 'calc(50% - 8px)' }}
                title={
                  <Space>
                    {
                      <Image
                        preview={false}
                        style={{ height: 50 }}
                        src={TemuIcon}
                        alt="temuImage"
                      />
                    }
                    <span>Sign in Account Information</span>
                  </Space>
                }
              >
                <Form.Item
                  name="Temu_WarehouseCode"
                  initialValue={info?.account}
                  label={<FormLabel>Temu Warehouse Code</FormLabel>}
                  rules={[
                    {
                      required: true,
                      message: 'Please input Temu Warehouse Code!',
                    },
                  ]}
                >
                  <Input id="temu_warehouseCode" />
                </Form.Item>

                {/*<Form.Item
                  name="Temu_ClientId"
                  initialValue={info?.clientId}
                  label={<FormLabel>Client ID</FormLabel>}
                  rules={[
                    {
                      required: true,
                      message: 'Please Input Client ID!',
                    },
                  ]}
                >
                  <Input id="temu_clientid" />
                </Form.Item>

                <Form.Item
                  name="Temu_ClientSecre"
                  initialValue={info ? '******' : undefined}
                  label={<FormLabel>Client Secret</FormLabel>}
                  rules={[
                    {
                      required: true,
                      message: 'Please Input Client Secret!',
                    },
                  ]}
                >
                  <Input id="temu_secret" />
                </Form.Item>

                <Form.Item
                  name="Temu_Code"
                  initialValue={info?.apiCode}
                  label={<FormLabel>API Code</FormLabel>}
                  rules={[
                    {
                      required: true,
                      message: 'Please Input API Code!',
                    },
                  ]}
                >
                  <Input id="temu_code" />
                </Form.Item>

                <Form.Item
                  name="Temu_TenantId"
                  initialValue={info?.tenantId}
                  label={<FormLabel>Tenant ID</FormLabel>}
                  rules={[
                    {
                      required: true,
                      message: 'Please Input Tenant ID!',
                    },
                  ]}
                >
                  <Input id="temu_tenantid" />
                </Form.Item>*/}

              </Card>
            </TwoCol>
          </>
        )}
      </Form>
    );
  }, [
    actionType,
    addressBook,
    carrier,
    carrierAccounts,
    carrierKeyValue,
    channelfulfillments,
    checkUpsAuthCode,
    form,
    getModeOptions,
    info,
    layout,
    mode,
    onUpsModeChange,
    providerAccounts,
    selectedAddress,
    selectedChannelAccountNum,
    selectedProviderAccount,
    selectedUsage,
    useSandbox,
    useProviderAccount,
    warehouses,
  ]);

  useEffect(() => {
    if (actionType === 'edit') {
      getAccountInfo();
    }
  }, [actionType, getAccountInfo]);
  useEffect(() => {
    fetchAddressBook();
  }, [fetchAddressBook]);

  useEffect(() => {
    if (addressBook.length > 0 && info) {
      setSelectedAddress(
        addressBook.filter(
          (item) => item.addressNum === info.addressDto?.addressNum
        )[0]
      );
    }
  }, [addressBook, info]);

  return (<>
    <ModalDialog
      centered
      className="fullscreen-modal"
      closable={false}
      closeButton={true}
      footer={<Space>
        <Button onClick={closeProductDetailDialog} icon={<CloseOutlined />}>
          Cancel
        </Button>
        <Button
          type="primary"
          loading={saveLoading}
          onClick={handleCreate}
          icon={actionType === 'add' ? <PlusOutlined /> : <SaveOutlined />}
          //disabled={!isFormTouched}
          disabled={!isFormSubmittable()}
        >
          {actionType === 'add' ? 'Add' : 'Save'}
        </Button>
      </Space>}
      fullscreen={true}
      maskClosable={false}
      onClose={closeProductDetailDialog}
      onFullscreen={onFullscreen}
      title={`${actionType === 'add' ? 'Add' : 'Edit'} ${getDialogTitle()} Account`}
      visible={props.visible}
      width={detailDialogWidth()}
      // titleRightCrumb={
      //   <Space>
      //     {isFormTouched && (
      //       <Button onClick={closeProductDetailDialog} icon={<CloseOutlined />}>
      //         Cancel
      //       </Button>
      //     )}
      //     <Button
      //       type="primary"
      //       loading={saveLoading}
      //       onClick={handleCreate}
      //       icon={actionType === 'add' ? <PlusOutlined /> : <SaveOutlined />}
      //       disabled={!isFormTouched}
      //     >
      //       {actionType === 'add' ? 'Add' : 'Save'}
      //     </Button>
      //   </Space>
      // }
    >
      {/* <Modal
      title={`${actionType === 'add' ? 'Add' : 'Edit'} ${
        carrierKeyValue[`${carrier}`]
      } Account`}
      centered
      visible={visible}
      maskClosable={false}
      width={1100}
      destroyOnClose={true}
      onCancel={handleCancel}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button
              id="add_or_save_button"
              key="submit"
              type="primary"
              onClick={handleCreate}
            >
              {actionType === 'add' ? <PlusOutlined /> : <SaveOutlined />}
              {actionType === 'add' ? 'Add' : 'Save'}
            </Button>
            <Button
              id="cancel_button"
              onClick={handleCancel}
              icon={<CloseOutlined />}
            >
              Cancel
            </Button>
          </Space>
        </Row>
      }
    > */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          // backgroundColor: '#fff',
          backgroundColor: theme['@default-backgroud-color'],
        }}
      >
        <Card
          bodyStyle={{ padding: 8, overflowY: 'auto', height: '100%' }}
          style={{ width: '100%', height: '100%' }}
          loading={loading}
        >
          {actionType === 'add'
            ? getForm()
            : info && addressBook.length > 0 && getForm()}
        </Card>
        {createlVisible && (
          <CreateAddressDialog
            visible
            onHide={() => setCreatelVisible(false)}
            onRefresh={() => fetchAddressBook()}
            address={addressAct === 'add' ? undefined : selectedAddress}
          />
        )}
      </div>
    </ModalDialog>
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};
